const categoryDropdown = () => {

  jQuery(document).ready(function($){
    $('input[data-dropdown-filter]').on('keyup',function(){

      let value = $(this).val(),
          search = new RegExp('' + value.toLowerCase() + '', 'gm');


      const dropdownID = $(this).data('dropdown-filter');

      $('#'+dropdownID + ' [data-filter-text]').each(function( index ) {

        let filter = $(this).data('filter-text').toLowerCase();

        if(filter.match(search)) {
          $(this).removeClass('--noresult');
        } else {
          $(this).addClass('--noresult');
        }

      });


    });

    $('.c-category__dropdown__category__item--toggle').on('click',function(e){

      e.preventDefault();

      let $column = $(this).parent(),
          $toggle = $(this);

      $column.find('.--toggleable').toggleClass('--show');
      $toggle.slideUp();

    });

    $('.c-category__dropdown__category__toggle').on('click',function (e) {
      e.preventDefault();

      let $column = $(this).closest('.c-category__dropdown__categories'),
          $toggle = $(this);

      $column.find('.c-category__dropdown__category.--toggleable').toggleClass('--show');
      $toggle.toggleClass('--show');
    })

  });

};

export default categoryDropdown;
